/**
 * GarageWhiz — Scroll Reveal Animations
 * Uses IntersectionObserver for performant scroll-triggered animations.
 */
(function() {
  'use strict';

  const THRESHOLD = 0.15;

  function initScrollReveal() {
    const elements = document.querySelectorAll('[data-animate]');
    if (!elements.length) return;

    // Respect reduced motion preference
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elements.forEach(function(el) {
        el.classList.add('is-visible');
      });
      return;
    }

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: THRESHOLD,
      rootMargin: '0px 0px -50px 0px'
    });

    elements.forEach(function(el, index) {
      // Stagger delay for grouped items
      el.style.transitionDelay = (index % 6) * 60 + 'ms';
      observer.observe(el);
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollReveal);
  } else {
    initScrollReveal();
  }
})();
